import React from 'react';
import { connect } from 'react-redux';
import DietContainer from '../diets/DietContainer';
import { Link } from 'react-router';
import menuIcon from '../assets/img/icon-menu.png';

class MenuBar extends React.Component {

	constructor() {
		super();
		this.state = {
			open: false
		}
	}

	render() {
		return (
			<div>
				<div className="brand-bar bg-default">
					{this.props.back?
						<Link to="/app">
							<div className="col-xs-6 logo">
								<i className="glyphicon glyphicon-arrow-left" />
							</div>
						</Link>:
						<div className="col-xs-6 logo" />
					}
					<div className="col-xs-6 menu-button">
						<button
							className="btn btn-brand btn-sm pull-right"
							onClick={() => this.setState({open: !this.state.open})}>
							<img
								src={menuIcon}
								style={{
									width: '20px',
									height: '13px',
									marginRight: '7px',
								}} />
							Deine Ernährung
						</button>
					</div>
				</div>
				<DietContainer
					warnings={this.props.gui.warnings}
					open={this.state.open? "in": ""}
					closeDiets={() => this.setState({open: false})} />
				
			</div>
		)
	}
};

const mapStateToProps = state => ({
	gui: state.gui,
})

const mapDispatchToProps = dispatch => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(MenuBar);


// export default MenuBar;


// WEBPACK FOOTER //
// ./src/gui/MenuBar.js